import { EMediaModelTypes } from '../types/media.types';

export const MediaModelTypesMap = {
  [EMediaModelTypes.USER]: {
    name: 'User',
    url: '/users/edit?id=',
  },
  [EMediaModelTypes.COMPANY]: {
    name: 'Company',
    url: '/companies/edit?id=',
  },
  [EMediaModelTypes.PRODUCTION_DEVICE]: {
    name: 'Production Device',
    url: '/eecs-go/eecs-pds/edit/',
  },
};
